import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { BottomSheet, type UseModalState } from "@src/appV2/redesign/system/ui-components";

import { type PlacementWithDetails } from "../api/useFetchPaginatedPlacements";
import { AlternativeAddressInfo } from "./AlternativeAddressInfo";
import { type AlternativeAddressData } from "./PlacementDetailsPage/hooks/useAlternativeAddress";

interface AlternativeAddressModalProps {
  modalState: UseModalState;
  placementDetails: PlacementWithDetails;
  alternativeAddressData: AlternativeAddressData;
  onClose: () => void;
  onContinue: () => void;
}

export function AlternativeAddressModal(props: AlternativeAddressModalProps) {
  const { modalState, placementDetails, alternativeAddressData, onClose, onContinue } = props;
  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical" onClose={onClose}>
          <Button fullWidth variant="contained" size="large" onClick={onContinue}>
            OK, let’s book the interview
          </Button>
        </DialogFooter>
      }
    >
      <Stack sx={{ p: 8 }}>
        <AlternativeAddressInfo
          placementDetails={placementDetails}
          alternativeAddressData={alternativeAddressData}
        />
      </Stack>
    </BottomSheet>
  );
}
